// firebase/zoomService.js
import { getFunctions, httpsCallable } from 'firebase/functions';

class ZoomService {
  constructor() {
    this.functions = getFunctions();
  }

  async createMeeting(meetingData) {
    try {
      const createZoomMeeting = httpsCallable(this.functions, 'createZoomMeeting');
      const result = await createZoomMeeting(meetingData);
      
      return result.data;
    } catch (error) {
      console.error('Error creating Zoom meeting:', error);
      throw error;
    }
  }
}

export default new ZoomService();